import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a stop icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <StopIcon width={12} />
 */
const StopIcon = props => (
    <SvgIcon {...props}>
        <path d="M8 8h32v32H8z" />
    </SvgIcon>
)

StopIcon.defaultProps = defaultProps

export { StopIcon }
